import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    // Message Role Enum
    'resource:data.enums.messageRole',
    'resource:data.enums.messageRole.entries.user',
    'resource:data.enums.messageRole.entries.agent',
    // Message Status Enum
    'resource:data.enums.messageStatus',
    'resource:data.enums.messageStatus.entries.pending',
    'resource:data.enums.messageStatus.entries.completed',
    'resource:data.enums.messageStatus.entries.failed',
    // Workspaces Dimension
    'resource:data.dimensions.workspaces',
    // Workspace Entity
    'resource:data.dimensions.workspaces.entities.workspace',
    'resource:data.dimensions.workspaces.entities.workspace.attributes.createdAt',
    'resource:data.dimensions.workspaces.entities.workspace.attributes.ownerId',
    'resource:data.dimensions.workspaces.entities.workspace.attributes.sharedWith',
    // Conversations Dimension
    'resource:data.dimensions.conversations',
    // Conversation Entity
    'resource:data.dimensions.conversations.entities.conversation',
    'resource:data.dimensions.conversations.entities.conversation.attributes.createdAt',
    'resource:data.dimensions.conversations.entities.conversation.attributes.conversationEntity',
    'resource:data.dimensions.conversations.entities.conversation.attributes.ownerId',
    'resource:data.dimensions.conversations.entities.conversation.attributes.sharedWith',
    'resource:data.dimensions.conversations.entities.conversation.attributes.workspace',
    // Message Entity
    'resource:data.dimensions.conversations.entities.message',
    'resource:data.dimensions.conversations.entities.message.attributes.createdAt',
    'resource:data.dimensions.conversations.entities.message.attributes.role',
    'resource:data.dimensions.conversations.entities.message.attributes.info',
    'resource:data.dimensions.conversations.entities.message.attributes.status',
    // Message Info Snapshot
    'resource:data.dimensions.conversations.snapshots.messageInfo',
    'resource:data.dimensions.conversations.snapshots.messageInfo.attributes.seq',
    'resource:data.dimensions.conversations.snapshots.messageInfo.attributes.entry',
  ],
  description:
    'Entities and enums for managing conversational agent interactions and messages',
  name: 'Assistant Chat',
} as const satisfies core.quiver.Package
